import { TEMPLATE_AVAILABILITY } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useTemplateAvailability() {
  return useIsFeatureEnabled(TEMPLATE_AVAILABILITY);
}
